import {useEffect} from "react";
import './App.css';
import Navbar from "./components/navbar";
import Board from "./components/TileBoard";
import Keyboard from "./components/Keyboard";
import {createContext, useState} from "react";
import {Matrix} from "./components/Matrix";
import tw from "twin.macro";
import styled from "styled-components";
import {generateWordSet} from "./components/Matrix";
import GameOver from "./components/GameOver";

export const AppContext = createContext()

const AppContainer = styled.div`
  ${tw`
    w-full
    h-screen
    `}
`

const AppStyle = styled.div`
  min-width: 320px;
  ${tw`
    h-full
    w-full
    bg-black
    flex
    flex-col
    justify-between
    items-stretch 

    `}
`

function App() {
    const [board, setBoard] = useState(Matrix)
    const [currAttempt, setCurrAttempt] = useState({attempt: 0, letterPos: 0})
    const [wordset, setWordSet] = useState(new Set())
    const [disabledLetters, setDisabledLetters] = useState([])
    const [almostLetters, setAlmostLetters] = useState([])
    const [errorLetters, setErrorLetters] = useState([])
    const [correctLetters, setCorrectLetters] = useState([])
    const [gameover, setGameover] = useState({gameOver: false, guessedWord: false})
    const [correctWord, setCorrectword] = useState("")

    useEffect(() => {
        generateWordSet().then((words) => {
            setWordSet(words.wordSet)
            setCorrectword(words.todaysWord)
        })
    }, [])

    const onSelectLetter = (keyVal) => {
        if (currAttempt.letterPos > 4) return
        const newBoard = [...board]
        newBoard[currAttempt.attempt][currAttempt.letterPos] = keyVal
        setBoard(newBoard)
        setCurrAttempt({...currAttempt, letterPos: currAttempt.letterPos + 1})
    };

    const onDelete = () => {
        if (currAttempt.letterPos === 0) return
        const newBoard = [...board]
        newBoard[currAttempt.attempt][currAttempt.letterPos - 1] = ""
        setBoard(newBoard)
        setCurrAttempt({...currAttempt, letterPos: currAttempt.letterPos - 1})
    };

    const onEnter = () => {
        if (currAttempt.letterPos !== 5) return
        let currWord = "";
        for (let i = 0; i < 5; i++) {
            currWord += board[currAttempt.attempt][i]
        }

        if (wordset.has(currWord.toLowerCase())) {
            setCurrAttempt({attempt: currAttempt.attempt + 1, letterPos: 0})
        } else {
            alert("not found")
        }

        if (currWord === correctWord) {
            setGameover({gameOver: true, guessedWord: true})
            return
        }

        if (currAttempt.attempt === 5 && wordset.has(currWord)) {
            setGameover({gameOver: true, guessedWord: false})
        }
    };

    return (
        <AppContainer>
            <AppStyle>
                <Navbar />
                <AppContext.Provider value={{
                    board,
                    setBoard,
                    currAttempt,
                    setCurrAttempt,
                    onSelectLetter,
                    onDelete,
                    onEnter,
                    correctWord,
                    disabledLetters,
                    setDisabledLetters,
                    gameover,
                    setGameover,
                    almostLetters,
                    errorLetters,
                    setAlmostLetters,
                    setErrorLetters,
                    correctLetters,
                    setCorrectLetters
                }}>
                    <Board />
                    {gameover.gameOver ? <GameOver /> : <Keyboard />}
                </AppContext.Provider>
            </AppStyle>
        </AppContainer>
    );
}

export default App;

